import { http } from '../../config/axios'

export default function getOpcoesConsulta(): Promise<any[]> {
  return http
    .get('api/permissao/opcoesconsulta')
    .then((res) => {
      return res.data as any[]
    })
    .catch((error) => {
      console.error('Erro getOpcoesConsulta', error)
      throw Error(error.response.data)
    })
}
